<template>
  <div class="interview-result-item">
    <div class="message other">
      <div class="avatar-wrapper">
        <img
          src="https://logo.wondercv.com/banners/OSklM7tbYeEKNLH.png"
          alt=""
        />
      </div>
      <div class="message-text-content">
        <div class="message-text">{{ message.question }}</div>
      </div>
    </div>
    <div v-if="message.logic || message.answer" class="message me">
      <div class="avatar-wrapper">
        <img :src="userAvatar" alt="" />
      </div>
      <div class="message-text-content">
        <div v-if="message.logic" class="message-text">
          面试思路：{{ message.logic }}
        </div>
        <br />
        <div v-if="message.answer" class="message-text">
          面试话术：{{ message.answer }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "MessageItem",
  props: {
    message: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState("me", ["personInfo"]),
    userAvatar() {
      return this.personInfo.avatar_url;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.interview-result-item {
  .message {
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;
    &.me {
      flex-direction: row-reverse;
      .avatar-wrapper {
        margin-left: 12px;
        margin-right: 0;
      }
      .message-text-content {
        background-color: #ff5733;
        border-radius: 6px 0 6px 6px;
        color: #fff;
        width: 438px;
        box-sizing: border-box;
      }
    }
    .avatar-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 12px;
      flex-shrink: 0;
      img {
        width: 32px;
        height: 32px;
        object-fit: cover;
      }
    }
    .message-text-content {
      padding: 12px 16px;
      border-radius: 0 6px 6px 6px;
      background-color: $form-bg-color;
      font-size: 14px;
      line-height: 16px;
      color: $text-color;
      max-width: 438px;
      .message-text {
        white-space: pre-line;
      }
    }
  }
}
</style>
